module.exports = __webpack_public_path__ + "img/work-hard.4747e1f2.svg";